

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {KhachHang} from "@/models/khachHang";
import {ThanhPhan} from "@/models/thanhPhan";
import { useConfirm } from "primevue/useconfirm";
import {HoaDonCreate} from "@/models/hoaDonCreate";
import {HoaDon} from "@/models/hoaDon";
import {HoaDonDetail} from "@/models/hoaDonDetail";
import {DoanhThu} from "@/models/doanhThu";
import {LichSuLieuTrinh} from "@/models/lichSuLieuTrinh";
import {ThucHienLieuTrinhCreate} from "@/models/thucHienLieuTrinhCreate";
import router from "@/router";


export default {

  setup(){
    const confirm = useConfirm();
    const router = useRouter();
    const tongTien = ref(0);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const giamPhanTram = ref(0);
    const giamGia = ref(0);
    const tongThucThu = ref(0);
    const traTruoc = ref(0);
    const conLai = ref(0);
    const confirmTransaction = ref(false);
    const date = ref();
    const listHoaDon = ref([] as HoaDonDetail[]);
    const listLichSuLieuTrinh = ref([] as LichSuLieuTrinh[]);
    const doanhThu = ref({} as DoanhThu);
    const thucHienLieuTrinhCreate = ref({} as ThucHienLieuTrinhCreate);
    const showDoanhThu = ref(false);
    const showThucHienLT = ref(false);
    if (!!!store.state.token) {
      router.push({ name: "home" });
    }
    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return ""
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatCurrency = (money) => {
      // Use Intl.NumberFormat to format the number as currency
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0, // Set the number of decimal places you want
      });
      if(money > 0) {
        return formatter.format(money);
      }
      else
      {
        return '';
      }
    };

    const tongTienFormatted = computed(() => {
      return formatCurrency(tongTien.value);
    });

    const clickXuLy= () => {
      confirmTransaction.value = true;
      traTruoc.value = tongThucThu.value;
    }

    const clickTraTruoc = () => {
      conLai.value = tongThucThu.value - traTruoc.value;
    }

    const clickThanhToan = () => {
      toast.add({ severity: 'info', summary: 'Xác nhận', detail: 'Thanh toán thành công '+conLai.value , life: 6000 });
    }


    const clearCalendar = () => {
      console.log("@@@@@@@@@################ clearDate");
      date.value = new Date();
      listHoaDon.value = [];
    }

    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null)){
        AuthRepository.getListHoaDonAll(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              listHoaDon.value = response.data;
              AuthRepository.getDoanhThu(listHoaDon.value)
                  .then((response) => {
                    doanhThu.value = response.data;
                  })
                  .catch(err => {
                    // toast.add({
                    //   severity: 'error',
                    //   summary: 'Lỗi',
                    //   detail:err.response.data,
                    //   life: 2000
                    // });
                  });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Không tìm thấy dữ liệu trong khoảng thời gian lựa chọn',
                life: 3000
              });
            });
      }
    }

    const clickDoanhThu = () => {
      showDoanhThu.value = true;
    }

    return {
      error,
      formatDateTime,
      filters,
      clearFilter,
      initFilters,
      formatCurrency,
      tongTien,
      tongTienFormatted,
      giamPhanTram,
      giamGia,
      tongThucThu,
      clickThanhToan,
      confirmTransaction,
      clickXuLy,
      traTruoc,
      clickTraTruoc,
      conLai,
      listHoaDon,
      selectCalendar,
      clearCalendar,
      date,
      doanhThu,
      showDoanhThu,
      clickDoanhThu,
      listLichSuLieuTrinh,
      thucHienLieuTrinhCreate,
      showThucHienLT,
    }
  }
}

